import { Radar } from 'vue-chartjs'

export default {
  extends: Radar,
  data: () => ({
    chartdata: {
      labels: ['Running', 'Swimming', 'Eating', 'Cycling', 'Coding','Reading'],
      datasets: [
        {
         
          label:"Marti",
          backgroundColor: 'rgba(0,51,255,0.3)',
          borderColor:'rgba(0,51,255,1)',
          data: [80, 40, 20, 20,20, 80]
        },
        {
         
          label:"leo",
          backgroundColor: 'rgba(0,0,0,0.5)',
          borderColor:'rgba(0, 0, 0, 1)',
          data: [10, 20, 100, 60,80, 30]
        },
      
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false
    }
  }),

  mounted () {
    this.renderChart(this.chartdata, this.options)
  }
}